export const queryKeys = {
  getRoles: "getRoles",
  getRole: "getRole",
};
